// extracted by mini-css-extract-plugin
module.exports = {"amount":"Amount__amount--3UctQeB8fFByETyxLQ-ZSC","smallText":"Amount__small-text--FYJjoGG4QTrx9K2DQL9CL"};